<script setup lang="ts">
import { useDisplay } from "vuetify";
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { name } = useDisplay();

function card_width(): string {
  switch (name.value) {
    case "xs":
    case "sm":
      return "w-100";
    default:
      return "w-50";
  }
}
</script>

<template>
  <v-container class="pa-0 d-flex justify-center align-center" style="height: 100%" fill-height fluid>
    <v-row no-gutters>
      <v-spacer />
      <v-col>
        <v-card
          color="card-background"
          elevation="3"
          :class="`${card_width} mx-5`"
          max-width="500"
        >
          <v-sheet color="card-header" class="py-2">
            <v-card-title color="secondary">
              {{ t("howto") }}
            </v-card-title>
          </v-sheet>
          <v-divider />
          <v-card-text class="text-info ml-6">
            <ul>
              <li>{{ t("scan") }}</li>
              <li>{{ t("goto") }}</li>
              <li>{{ t("login") }}</li>
              <li>{{ t("plugin") }}</li>
              <li>{{ t("start") }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<i18n lang="yaml">
en:
  howto: "How to use our service"
  scan: "Scan station's QR code"
  goto: "Go to the given url"
  login: "Log in with an authorized account or pay with a card"
  plugin: "Plug in your cable"
  start: "Start your charge!"
it:
  howto: "Come usufruire dei nostri servizi"
  scan: "Scansiona il QR code della colonnina"
  goto: "Vai al link generato"
  login: "Accedi con un account autorizzato o paga con una carta"
  plugin: "Inserisci il cavo per la ricarica"
  start: "Avvia la carica!"
fr:
  howto: "Comment utiliser notre service"
  scan: "Scannez le QR code de la station"
  goto: "Rendez-vous à l'adresse obtenue"
  login: "Connectez-vous avec un compte autorisé ou payez avec une carte"
  plugin: "Branchez votre câble"
  start: "Démarrez votre charge!"
de:
  howto: "Vorgänge zum Aufladen"
  scan: "Scannen Sie den QR-Code der Stromtankstelle"
  goto: "Gehen Sie zum generierten link"
  login: "Melden Sie sich mit Ihren Zugangsdaten an oder zahlen Sie per Kreditkarte"
  plugin: "Ladekabel einstecken"
  start: "Beginnt zu laden!"
nl:
  howto: "Hoe onze service gebruiken"
  scan: "Scan de QR-code van het station"
  goto: "Ga naar het verkregen adres"
  login: "Meld u aan met een toegelaten account of betaal met een kaart"
  plugin: "Sluit uw kabel aan"
  start: "Begin met opladen"
</i18n>

<style scoped lang="scss">
</style>

<!-- vim: softtabstop=2:shiftwidth=2
-->
